/* ==================================================================
   North Shore Peptides — Header behavior
   Sticky state · accessible mega menu · mobile drawer
   ================================================================== */
(function () {
  'use strict';

  function initHeader(root) {
    if (!root || root.dataset.npInit === 'true') return;
    root.dataset.npInit = 'true';

    var DESKTOP = window.matchMedia('(min-width: 990px)');

    /* ---------- Sticky / scrolled state + header height var ---------- */
    var scrollThreshold = parseInt(root.dataset.scrollThreshold || '24', 10);
    var ticking = false;

    // Transparent overlay only applies on pages that actually have a hero
    var transparent = root.classList.contains('np-header--transparent');
    var hasHero = !!document.querySelector('.np-hero');
    if (transparent && !hasHero) {
      root.classList.remove('np-header--transparent');
      transparent = false;
    }
    if (transparent && hasHero) {
      document.body.classList.add('np-overlay-header');
    }

    function setHeight() {
      var bar = root.querySelector('.np-header__surface') || root;
      root.style.setProperty('--np-header-height', bar.offsetHeight + 'px');
      document.documentElement.style.setProperty('--np-header-height', bar.offsetHeight + 'px');
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        var scrolled = window.scrollY > scrollThreshold;
        root.classList.toggle('np-header--scrolled', scrolled);
        if (transparent) root.classList.toggle('np-header--at-top', !scrolled);
        ticking = false;
      });
    }
    setHeight();
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', setHeight);

    /* ---------- Mega menu ---------- */
    var items = root.querySelectorAll('.np-nav__item--has-menu');
    var closeTimer;

    function openItem(item) {
      window.clearTimeout(closeTimer);
      items.forEach(function (other) {
        if (other !== item) closeItem(other);
      });
      item.dataset.open = 'true';
      var trigger = item.querySelector('.np-nav__link');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
    }
    function closeItem(item) {
      item.dataset.open = 'false';
      var trigger = item.querySelector('.np-nav__link');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    }
    function closeAll() {
      items.forEach(closeItem);
    }

    items.forEach(function (item) {
      var trigger = item.querySelector('.np-nav__link');

      // Pointer (desktop) hover
      item.addEventListener('mouseenter', function () {
        if (DESKTOP.matches) openItem(item);
      });
      item.addEventListener('mouseleave', function () {
        if (DESKTOP.matches) {
          closeTimer = window.setTimeout(function () { closeItem(item); }, 120);
        }
      });

      // Click / touch toggle (works on all sizes for button triggers)
      if (trigger && trigger.tagName === 'BUTTON') {
        trigger.addEventListener('click', function (e) {
          e.preventDefault();
          if (item.dataset.open === 'true') closeItem(item);
          else openItem(item);
        });
      }

      // Keyboard focus management
      item.addEventListener('focusin', function () { openItem(item); });
      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) closeItem(item);
      });
    });

    // Escape + outside click
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll();
    });
    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) closeAll();
    });

    /* ---------- Mobile drawer ---------- */
    var drawer = root.querySelector('.np-drawer');
    var openBtn = root.querySelector('.np-header__nav-trigger');
    var closeBtn = drawer && drawer.querySelector('.np-drawer__close');
    var overlay = drawer && drawer.querySelector('.np-drawer__overlay');
    var lastFocused = null;

    function openDrawer() {
      if (!drawer) return;
      lastFocused = document.activeElement;
      drawer.dataset.open = 'true';
      document.body.style.overflow = 'hidden';
      if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
      window.setTimeout(function () { if (closeBtn) closeBtn.focus(); }, 60);
      document.addEventListener('keydown', drawerKeydown);
    }
    function closeDrawer() {
      if (!drawer) return;
      drawer.dataset.open = 'false';
      document.body.style.overflow = '';
      if (openBtn) {
        openBtn.setAttribute('aria-expanded', 'false');
        openBtn.focus();
      }
      document.removeEventListener('keydown', drawerKeydown);
    }
    function drawerKeydown(e) {
      if (e.key === 'Escape') { closeDrawer(); return; }
      if (e.key !== 'Tab') return;
      // Simple focus trap
      var focusables = drawer.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])');
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    if (openBtn) openBtn.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);

    // Drawer accordion submenus
    if (drawer) {
      drawer.querySelectorAll('.np-drawer__toggle').forEach(function (toggle) {
        toggle.addEventListener('click', function () {
          var li = toggle.closest('.np-drawer__item');
          var isOpen = li.dataset.open === 'true';
          li.dataset.open = isOpen ? 'false' : 'true';
          toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        });
      });
    }
  }

  function initAll() {
    document.querySelectorAll('.np-header').forEach(initHeader);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Theme editor: re-init when the header section is reloaded
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.np-header');
    if (el) { el.dataset.npInit = ''; initHeader(el); }
  });
})();
